module.exports = __webpack_public_path__ + "static/img/jrtj_02.737bdec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jrtj_02.png
// module id = Kj+d
// module chunks = 8